<div class="conditional__options-list">
  @for (option of npsAreas; track option.value) {
    <mat-checkbox
      class="conditional__options-list-option"
      color="primary"
      [labelPosition]="'before'"
      [checked]="surveyConditionalsService.conditionFormValues$().valueToMatch?.includes(option.value)"
      (change)="surveyConditionalsService.onFormMultiOptionChanged($event, option.value)"
    >
      {{ option.text }}
    </mat-checkbox>
  }
</div>
